/*
 * $Id:: UserInfo.js 2020/11/12 06:07 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';

import { globals as globalsSlice } from '../../app/globalsSlice';
import { ReactComponent as LaunchIcon } from '../../assets/images/launch_24px.svg';
import { ReactComponent as SupervisedUser } from '../../assets/images/supervised_user_circle_24px.svg';
import { t } from '../../providers';
import ExternalLinks from '../ExternalLinks';

const useStyles = makeStyles((theme) => ({
    headerRightSection: {
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'center',
        justifyContent: 'flex-end',
        '@media (max-width:1100px)': {
            flexFlow: 'row nowrap',
        },
    },
    headerUser: {
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginLeft: '30px',
        '@media (max-width:1100px)': {
            marginLeft: '10px',
            justifyContent: 'center',
        },
        '@media (max-width:1010px)': {
            marginLeft: '0px',
            width: 'min-content',
        },
    },
    userArea: {
        display: 'flex',
        flexFlow: 'row nowrap',
        marginRight: '2rem',
        '@media (max-width:1100px)': {
            marginRight: '15px',
        },
        '@media (max-width:980px)': {
            marginRight: '10px',
        },
    },
    userInfo: {
        marginLeft: '4px',
        display: 'inline-grid',
    },
    userRole: {
        color: '#90A4AE',
        lineHeight: '12px',
        letterSpacing: '0',
        fontSize: '10px',
        fontWeight: '600',
    },
    userName: {
        fontSize: '14px',
        fontWeight: '600',
        lineHeight: '16px',
        color: theme.palette.svg.main,
        letterSpacing: '0',
    },
    logout: {
        height: '2.5rem',
        minWidth: '4.5rem',
        color: theme.palette.text.mainBlue + '!important', //
        border: '1px solid' + theme.palette.text.mainBlue,
    },
    externalLinks: {
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    buttonLink: {
        // margin: '0 23px 0 0 !important',
        // padding: '0px',
        '& svg path': {
            fill: 'rgba(0, 0, 0, 0.54)',
        },
        '& .MuiButton-label': {
            color: theme.palette.svg.main,
        },
    },
}));

const UserInfo = ({ user, logout }) => {
    const classes = useStyles();
    const { globals } = useSelector(globalsSlice) || {};
    const accountDetails = user.userDetails && user.userDetails.accountTypeDetails;
    const headerExternalLinks = globals && globals.header && Object.values(globals.header);

    //  set role
    let role = '';
    if (user.userRole) {
        role = user.userRole;
    } else {
        if (user.userType === 'CHILD' && accountDetails) {
            role = accountDetails.personType;
        }
    }

    return (
        <div className={classes.headerRightSection} data-testid="UserInfoTestId">
            {/** externalLinks */}
            <div className={classes.headerUser}>
                <div className={classes.userArea}>
                    <SupervisedUser />
                    <div className={classes.userInfo}>
                        <Typography variant="body2" className={classes.userName}>
                            {user.fullName}
                        </Typography>
                        <Typography variant="overline" className={classes.userRole}>
                            {role ? t(role.toLowerCase()) : ''}
                        </Typography>
                    </div>
                </div>
                <Button onClick={logout} className={classes.logout} disableRipple disableFocusRipple>
                    {t('log.out')}
                </Button>
            </div>
        </div>
    );
};

export default UserInfo;
